import React from 'react';

import { EImageSource } from '@sharedComponents/Images';
import { Bold } from '@styles/generalStyles';
import { ReactFCV } from '@types';

import { Image, ItemInfo, ItemSubName, Product } from './styled';

export interface IGiftItemProps {
  brand: string;
  collection: string;
  subName: string;
  imageUrl: string;
}

export const GiftItem: ReactFCV<IGiftItemProps> = ({ brand, collection, subName, imageUrl }) => {
  return (
    <Product data-testid="gift-item">
      <Image url={imageUrl} sourceKey={EImageSource.ORDER} width={165} height={165} />
      <ItemInfo data-testid="gift-info">
        {brand} <Bold data-testid="gift-collection">{collection}</Bold>
        <ItemSubName data-testid="gift-sub-name">{subName}</ItemSubName>
      </ItemInfo>
    </Product>
  );
};
